import styled from '@emotion/styled';
import { borderRadius, breakpoints, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { GridCol } from '@naf/grid';
import { Tag } from '@naf-simba/elements-tag';
import { Text } from '@naf/text';
import { colors } from '@naf-simba/theme';
import { DisplayStyle } from '../../../../../../../types/centerArticleType';

export const ProductPairCol = styled(GridCol)`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.space24};
  margin: ${spacing.space16} 0 ${spacing.space32};
  padding: 0 ${spacing.space48};

  @media (max-width: ${breakpoints.m}) {
    margin: ${spacing.space16} 0 ${spacing.space24};
    padding: 0 ${spacing.space24};
  }

  @media (max-width: ${breakpoints.s}) {
    flex-direction: column;
    gap: ${spacing.space40};
    padding: 0;
  }
`;

export const ProductPairBlock = styled.div`
  flex: 1 1 calc(50% - ${spacing.space12});
  display: flex;

  @media (max-width: ${breakpoints.s}) {
    flex: 1 1 100%;
  }
`;

export const Content = styled.div<{ $displayStyle?: DisplayStyle }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${spacing.space40};
  border-radius: ${borderRadius.L};
  background-color: ${({ $displayStyle }) =>
    $displayStyle === DisplayStyle.WithPricePrimaryButton ? 'transparent' : `${colors.secondary[50]}`};
  border: ${({ $displayStyle }) =>
    $displayStyle === DisplayStyle.WithPricePrimaryButton
      ? `3px solid ${colors.secondary[500]}`
      : `3px solid ${colors.secondary[50]}`};
`;

export const ButtonWrapper = styled.div`
  margin-top: auto;
  display: flex;
`;

export const StyledTitle = styled(Text)`
  margin: 0 0 ${spacing.space16} 0;
`;

export const StyledTag = styled(Tag)`
  display: flex;
  width: fit-content;
  margin-bottom: ${spacing.space12};

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: ${spacing.space8};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  white-space: pre;
  align-items: center;
`;

export const InlineText = styled(Text)`
  display: inline-flex;
  white-space: pre;
  margin: 0 0 ${spacing.space16} 0;
  font-weight: 400;
`;

export const Ingress = styled(Text)`
  margin: 0;
  margin-bottom: ${spacing.space16};
  font-style: italic;
`;

export const StyledBorderTag = styled(Tag)`
  position: absolute;
  top: -12px;
  left: ${spacing.space40};
`;

export const DesktopWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoints.s}) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.s}) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const ReadMoreWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const IngressMobileTitle = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  color: ${nafColor.signature.black};

  p {
    margin: 0;
    font-style: italic;
    font-weight: 700;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.space8};
`;

export const Chevron = styled.span<{ $isOpen: boolean }>`
  display: flex;
  transition: transform 0.3s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  color: ${nafColor.signature.black};
  margin-left: auto;
`;

export const IngressMobile = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
  margin-bottom: ${spacing.space16};

  p {
    margin: 0;
    font-style: italic;
    font-weight: 400;
  }
`;
